<template>
  <div class="app-header">
    <div class="app-header__logo">
      <Logo />
    </div>
  </div>
</template>

<script>
import Logo from './logo';

export default {
  components: { Logo },
};
</script>

<style lang="scss" scoped>
.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 56px;
  background: linear-gradient(to bottom, #CADDFC 0px, #CADDFC 50px, rgba(202, 221, 252, 0) 70px);
  margin-bottom: -10px;
}
</style>
